module.exports = __webpack_public_path__ + "icons/PhonePeLogo.a24268ab2c540daf071429e854656ac9.svg";